module.exports = __webpack_public_path__ + "img/alpha-year-menu2.6c1ffe3e.svg";